import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import VideoChat from "../components/video/VideoChat";
import LoadingSpinner from "../components/common/LoadingSpinner";

const VideoCallPage = () => {
  const [token, setToken] = useState<string>("");
  const [isLoading, setIsLoading] = useState(true);
  const { roomId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchToken = async () => {
      try {
        const response = await fetch("b828cecfd77f8341c1aefad0612b1e77", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ roomName: roomId }),
        });

        const data = await response.json();
        setToken(data.token);
      } catch (error) {
        console.error("Error fetching token:", error);
      } finally {
        setIsLoading(false);
      }
    };

    if (roomId) {
      fetchToken();
    }
  }, [roomId]);

  const handleEndCall = () => {
    navigate("/dashboard"); // Or wherever you want to redirect after call ends
  };

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (!token || !roomId) {
    return <div>Error joining video call</div>;
  }

  return (
    <VideoChat token={token} roomName={roomId} onEndCall={handleEndCall} />
  );
};

export default VideoCallPage;
